module.exports = __webpack_public_path__ + "img/home-setting-ware-4.85db10f3.png";